export default "__VITE_ASSET__1b61595f__"